<template>
	<div class="h-panel-body padding font-bold">
		<Row :space="9">
			<Cell width="6" v-for="(type,i) in typeList" :key="i">
				<div>
					<p>{{type.name}}</p>
          <!-- 显示指定类型的借方或贷方金额 -->
          <!-- 条件：当money对象中存在当前类型编码的数据，且该数据的借方金额或贷方金额不为空时 -->
          <!-- 内容：优先显示借方金额，如果借方金额为空则显示贷方金额，并通过numFormat过滤器进行格式化 -->
          <!--<p class="pnumber" v-if="money[type.code] && (money[type.code].debitAmount||money[type.code].creditAmount)">{{money[type.code].debitAmount||money[type.code].creditAmount|numFormat}}</p>-->

          <p class="pnumber" v-if="money[type.code] && (money[type.code].debitAmount || money[type.code].creditAmount)">
            {{ Math.abs((money[type.code].debitAmount || 0) - (money[type.code].creditAmount || 0)) | numFormat }}
          </p>
           <p class="pnumber" v-else>0.00</p>
          <button
              v-if="money[type.code] &&
                    money[type.code].debitAmount &&
                    money[type.code].creditAmount &&
                    money[type.code].debitAmount === money[type.code].creditAmount"
              class="h-btn h-btn-green">
            已结转凭证
          </button>
          <router-link v-else tag="button" :to="{name:'VoucherForm', params: { checkData,type }}"  class="h-btn h-btn-primary">生成凭证</router-link>

        </div>
			</Cell>
		</Row>
		<div align="center" style="margin-top: 20px;">
			<button class="h-btn h-btn-text-primary h-btn-transparent" @click="back">上一步</button>
			<button class="h-btn h-btn-primary" @click="check">下一步</button>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import StringUtils from 'string-utilz';
  import moment from 'moment';
  /**
   * 结账
   */
	export default {
		name: "checkout",
		props: {
			checkYear: [Number, String],
			checkMonth: [Number, String],
		},
		computed: {
			...mapState(['currentAccountSets']),
			typeList() {
				let isQy = this.currentAccountSets.accountingStandards === 0;
				return [

					{
						code: '3001,3002,3003,3004',
						type: 'jzsy',
						name: '结转损益',
						subject: [3001,3002,3003,3004,2001]
					},
          {
            code: '400%' ,
            type: 'yfzk',
            name: '结转拨款',
            subject: [4001,4002,4003,2001]
          },
          {
            code: '5001' ,
            type: 'sjkx',
            name: '结转上缴款项',
            subject: [5001,2001]
          },

				]
			}
		},
		data() {
			return {
				selected: 'carry-forward',
				checkData: {},
				money: {}
			}
		},
		methods: {

      /**
       * 查看已生成的凭证
       * @param {Number} voucherId - 凭证ID
       */
      viewVoucher(voucherId) {
        this.$router.push({name: 'VoucherForm', params: { voucherId }});
      },

      /**
       * 跳转到检查页面
       *
       * @description 该函数用于导航到名为'Check'的路由，并传递checkData作为路由参数
       * @returns {void}
       */
			check() {
				this.$router.push({name: 'Check', params: this.checkData})
			},
      /**
       * 返回上一页
       *
       * 该函数调用Vue Router的back方法，使浏览器返回到历史记录中的上一个页面。
       *
       * @returns {void}
       */
			back() {
				this.$router.back()
			},
      /**
       * 初始化函数，用于获取结转金额数据
       *
       * @description 调用API接口获取指定年月和类型的结转金额信息
       * @param {number} years - 检查年份
       * @param {number} month - 检查月份
       * @param {Array<string>} code - 类型列表对应的编码数组
       * @returns {Promise} 返回包含结转金额数据的Promise对象
       */
			init() {
        // 处理逗号分隔的code字符串
        let codes = [];
        this.typeList.forEach(val => {
          if (val.code.includes(',')) {
            codes.push(...val.code.split(','));
          } else {
            codes.push(val.code);
          }
        });
        this.$api.voucher.carryForwardMoney({
          years: this.checkYear,
          month: this.checkMonth,
          code: codes
        }).then(({data}) => {


          // 合并3001,3002,3003,3004的数据
          const mergedData = {...data};

          // 查找包含3001,3002,3003,3004的配置项
          const mergeConfig = this.typeList.find(type => type.code === '3001,3002,3003,3004');
          if (mergeConfig) {
            // 创建合并后的数据对象
            const mergedEntry = {
              debitAmount: 0,
              creditAmount: 0
            };

            // 合并3003,3004的数据
            [ '3001', '3002', '3003', '3004'].forEach(code => {
              if (data[code]) {
                mergedEntry.debitAmount += data[code].debitAmount || 0;
                mergedEntry.creditAmount += data[code].creditAmount || 0;
                // 如果有任何一个有voucherId，则使用它
                if (data[code].voucherId && !mergedEntry.voucherId) {
                  mergedEntry.voucherId = data[code].voucherId;
                }
              }
            });

            // 将合并后的数据添加到money对象中，使用原始code作为key
            mergedData[mergeConfig.code] = mergedEntry;
          }

          this.money = mergedData;
        });

			},
      /**
       * 代码转换函数
       * @param {string|number} code - 需要转换的代码
       * @returns {string} 转换后的代码
       */
			codeConversion(code) {
				code = String(code);
				let encoding = this.currentAccountSets.encoding.split('-');
        // 构造正则表达式验证代码格式
				let reg = RegExp(`^\\d{4}(\\d{${encoding[1]}|\\d{${encoding[1]}\\d{${encoding[2]}|\\d{${encoding[1]}\\d{${encoding[2]}\\d{${encoding[3]})$`);
        // 如果代码不符合指定格式，则进行更新处理
        if (!reg.test(code)) {
					code = this.updateCode(code, [4, 2, 2, 2], encoding);
				}
				return code;
			},
			updateCode(code, model, newModel) {
				let codeSp = [];
				let start = 0;
				for (let i in model) {
					let len = model[i];
					if (code.length <= start) {
						break;
					}
					codeSp.push(code.substring(start, Math.min(code.length, start + len)));
					start += len;
				}

				for (let i = 0; i < codeSp.length; i++) {
					let item = codeSp[i];
					let len = parseInt(newModel[i]);
					if (item) {
						if (item.length < len) {
							item = StringUtils.pad(item, item.length - len, "0");
						} else if (item.length > len) {
							item = item.substring(item.length - len);
						}
						codeSp[i] = item;
					}
				}

				return codeSp.join("");
			}
		},
		mounted() {
			// this.checkData = {checkYear: this.checkYear, checkMonth: this.checkMonth};
      this.checkData = {
        // 优先使用账套的当前日期，如果不存在再使用路由参数
        checkYear: this.currentAccountSets.currentAccountDate
            ? moment(this.currentAccountSets.currentAccountDate).year()
            : this.checkYear,
        checkMonth: this.currentAccountSets.currentAccountDate
            ? moment(this.currentAccountSets.currentAccountDate).month() + 1
            : this.checkMonth
      };

			this.init();
		},
    activated() {
      this.init();
    }
	}
</script>

<style lang="less" scoped>
	.h-row > div > div {
		padding: 8px;
		color: #000;
		border-radius: 3px;
		text-align: center;
		background-color: #Fff;
		height: 150px;
		line-height: 36px;
		border: 1px solid #eee;
	}

	.pnumber {
		margin: 5px 0;
		font-size: larger;
	}

</style>
